import Vue, { VueConstructor } from 'vue'

/*
    This is our home-brewed modal plugin, heavily inspired by vue-js-modal,
    but trimmed down to our minimum needs. Currently holds only cookie-consent,
    but could be easily enhanced.

    The main idea here is to have Vue prototype enhanced with globally-accessible
    $modal interface with useful methods. All components may call these, which causes
    the internal Vue instance called "subscription" to emit events, a bit like in the Event Bus pattern.
    These events are listened by modals and if their "name" matches - shown.
*/

type ModalModule = {
  show: (name: string, options?: any) => void
  hide: (name: string, options?: any) => void
  subscription: Vue
}

declare module 'vue/types/vue' {
  interface Vue {
    $rModal: ModalModule
  }
}

const Modal = (Vue: VueConstructor): ModalModule => {
  const subscription = new Vue()

  const show = (name: string, options?: any) => {
    subscription.$emit('show', { name, options })
  }

  const hide = (name: string, options?: any) => {
    subscription.$emit('hide', { name, options })
  }

  return {
    show,
    hide,
    subscription,
  }
}

const ModalPlugin = {
  install(Vue: VueConstructor) {
    Vue.prototype.$rModal = Modal(Vue)
  },
}

export default ModalPlugin
